var sw = sw || {};

// Scroll-to element
//-----------------------------------------------------------------
sw.scrollTo = function() {
    var $trigger = $('.menu__link');

    if (!$trigger.length) {
        return;
    }

    var _vpw = $(window).width();

    $trigger.on('click', function(e) {
        e.preventDefault();
        var $target = $(this).attr('href');

        if(_vpw < 1200) {
            $('html, body').animate({
                scrollTop: $($target).offset().top - $('.header').height()
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $($target).offset().top
            }, 1000);
        }

    });

    var $cta = $('.hero__cta a');

    $cta.on('click', function(e) {
    	e.preventDefault();
    	
        if(_vpw < 1200) {
            $('html, body').animate({
                scrollTop: $('#task').offset().top - $('.header').height()
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $('#task').offset().top
            }, 1000);
        }
    });

    var $link = $('.js_scrollTo');

    $link.on('click', function(e) {
        e.preventDefault();
        var $target = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $($target).offset().top
        }, 1000);
    });
};

// Change video for mobile/desktop
//-----------------------------------------------------------------
// sw.changeVideo = function() {

//     var video = $('#video');

//     if(!video.length) {
//         return;
//     }

//     //calculate inner height depending of viewport
//     var _vph = $(window).height();
//     var _vpw = $(window).width();

//     if(_vpw < 1200) {
//         $(video).html('<source src="../video/particles-vertical.mp4" type="video/mp4"></source>');
//     } else {
//         $(video).html('<source src="../video/particles.mp4" type="video/mp4"></source>');
//     }

// }

// Active menu element based on scroll
//-----------------------------------------------------------------
sw.activeElement = function() {

    var _vpw = $(window).width();

    function onScroll() {
        var scrollPos = $(document).scrollTop();
        $('.menu__link').each(function() {
            var currLink = $(this);
            var refElement = $(currLink.attr("href")).closest('section');
            if(refElement.position().top - $('.header').height() <= scrollPos && refElement.position().top - $('.header').height() + refElement.height() > scrollPos) {
               $('.menu__link').removeClass('active');
               currLink.addClass('active'); 
            } else {
                currLink.removeClass('active');
            }
        });
    }

    if(_vpw < 1200) {
        $(document).on('scroll', onScroll);
    } else {
        if($(window).scrollTop() === 0) {
            // $('.header').addClass('transparent');
        }
    }



};

// Timer
//-----------------------------------------------------------------
sw.countdown = function() {
    var $trig = $('.countdown__timer');

    if(!$trig.length) {
        return;
    }

    function makeTimer() {

    //      var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");  
        var endTime = new Date("26 May 2025 09:59:59 GMT+02:00");          
            endTime = (Date.parse(endTime) / 1000);

        var startTime = new Date("06 May 2025 23:59:59 GMT+02:00");
            startTime = (Date.parse(startTime) / 1000);

            var now = new Date();
            now = (Date.parse(now) / 1000);

            var timeLeft;

            if (startTime >= now) {
                timeLeft = startTime - now;
            } else {
                timeLeft = endTime - now;
            }

            var days = Math.floor(timeLeft / 86400); 
            var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
            var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
            var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
  
            if (hours < "10") { hours = "0" + hours; }
            if (minutes < "10") { minutes = "0" + minutes; }
            if (seconds < "10") { seconds = "0" + seconds; }

            $(".days").html(days + "<p>dana</p>");
            $(".hours").html(hours + "<p>sati</p>");
            $(".minutes").html(minutes + "<p>min.</p>");
            $(".seconds").html(seconds + "<p>sek.</p>");   

            if(endTime <= now) {
                $('.form--af').addClass('form--disabled');
                $('.form__textfield').attr('disabled', true);
                $('.checkbox-input').attr('disabled', true);
                $('.form__submit').attr('disabled', true);
                $('.countdown__timer').hide();
                $('.countdown__notice').html('Rok za prijavu i predaju rješenja za sudjelovanje je istekao.');
            }    


            if(startTime >= now) {
                $('.form--af').addClass('form--disabled');
                $('.form__textfield').attr('disabled', true);
                $('.checkbox-input').attr('disabled', true);
                $('.form__submit').attr('disabled', true);
                $('.countdown__notice').html('Rok za prijavu za sudjelovanje počinje 7. svibnja 2025.');
            }    

    }

    setInterval(function() { makeTimer(); }, 1000);
};

// Enable responsive youtube video
//-----------------------------------------------------------------
sw.responsiveVideo = function() {
    var $parentEl = $('.wysiwyg');

    if (!$parentEl.length) {
        return;
    }

    var $allVideos = $('iframe').filter(function(){return this.src.match(/(youtube\.com|youtu\.be)/i);});

    $allVideos.each(function() {
        var _aspectRatio = this.height / this.width * 100;

        $(this).wrap('<div class="video-container"></div>');
        $(this).parent().css('padding-bottom', _aspectRatio+'%');
    });
};

// Videoplayer
//-----------------------------------------------------------------
sw.videoplayer = function() {

    var $players = $('.js_videoPlayer');

    if(!$players.length) {
        return;
    }

    var player = Plyr.setup('.js_videoPlayer');
};


$(document).ready(function (){
    sw.scrollTo();
    // sw.changeVideo();
    sw.activeElement();
    sw.countdown();
    sw.responsiveVideo();
    sw.videoplayer();
});